import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';

const Wasn_best_paper = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                            className="header"
                        >
                        <h1 className="title">WASN 最佳論文</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">最佳論文候選名單</h2>
                        <ul className="list">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>1. WASN-14: GrCLR: Gradient Contrastive Learning for Human Motion Recognition Using Gradient Radar Combination Map</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>2. WASN-44: Digital Twin–Driven Energy-Efficient Scheduling for Automated Guided Vehicles in Smart Factories</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>3. WASN-39: 基於權重填充機制之網路流量分類應用於異質聯邦學習剪枝模型</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>4. WASN-45: SAMRL：基於自注意力機制之元強化學習多任務卸載策略</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>5. WASN-48: 無需座標資訊的地磁分群與室內地磁地圖建構：基於Transformer之無監督學習架構</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>6. WASN-57: PUF-Based Two-Stage Authentication Method for Bluetooth Low Energy in Smart Factories</li>
                        </ul>
                    </section>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">最佳學生論文候選名單</h2>
                        <ul className="list">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>1. WASN-07: Energy-Efficient Clustering and Path Optimization for UAV-Assisted Wireless Powered Communication Networks</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>2. WASN-24: 物聯網於健康照護監控系統之應用 Application of IoT in Healthcare Monitoring System</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>3. WASN-58: 利用多代理人強化式學習優化無人機網路部署與資源分配之公平性與能源效率</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>4. WASN-56: 植基於多模態視覺感知網路於即時語意建構之手語轉譯研究</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>5. WASN-82: 基於檢索增強生成的大型語言模型於汽車廠牌型號辨識之應用</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>6. WASN-70: UAV-Assisted Dynamic Relay Networks for Extending Wireless Communication to Coverage-Limited Regions</li>
                        </ul>
                    </section>
                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Wasn_best_paper;